'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Actions = require('./Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Svg = require('./Svg');

var _Svg2 = _interopRequireDefault(_Svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LinkedIn = function LinkedIn(_ref) {
  var width = _ref.width,
      link = _ref.link,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ['width', 'link', 'title']);

  return _react2.default.createElement(
    _Button2.default,
    _extends({ title: title, width: width, href: link, onClick: link ? undefined : _Actions2.default['linkedin']
    }, props),
    _react2.default.createElement(
      _Svg2.default,
      _extends({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: width, viewBox: '0 0 33 33' }, props),
      _react2.default.createElement(
        'title',
        null,
        title,
        ' button'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'transparent', fillRule: 'evenodd', transform: 'translate(.015 1)' },
        _react2.default.createElement('ellipse', { cx: '16.387', cy: '15.606', rx: '15.599', ry: '15.606' }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(10.242 7.567)' },
          _react2.default.createElement('path', { d: 'M1.874.015c1.032 0 1.872.714 1.872 1.592 0 .879-.84 1.592-1.872 1.592C.838 3.2 0 2.486 0 1.607 0 .729.838.015 1.874.015zM.257 13.241h3.231V4.407H.258v8.834z' })
        ),
        _react2.default.createElement('path', { d: 'M14.968 11.58h2.617v1.26h.037c.364-.725 1.254-1.49 2.582-1.49 2.763 0 3.273 1.911 3.273 4.396v5.062H20.75V16.32c0-1.07-.019-2.447-1.418-2.447-1.42 0-1.637 1.166-1.637 2.37v4.565h-2.727v-9.229z' })
      )
    )
  );
};

LinkedIn.defaultProps = {
  title: "Share on LinkedIn"
};

exports.default = LinkedIn;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-social-share/dist/components/Linkedin.js
// module id = 443
// module chunks = 168707334958949